import React from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import Swal from "sweetalert2"

import contactFormStyles from "../Styles/contactForm.module.css"

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const Contact = () => (
  <div>
    <h1 className={contactFormStyles.h1}>Contactame</h1>
    <Formik
      initialValues={{ name: "", email: "", message: "" }}
      validate={values => {
        const errors = {}
        if (!values.email) {
          errors.email = "Required"
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
          errors.email = "Invalid email address"
        }
        return errors
      }}
      onSubmit={(values, actions) => {
        fetch("/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: encode({ "form-name": "contact", ...values }),
        })
          .then(() => {
            Swal.fire({
              title: "Mensaje enviado!",
              text: "Gracias por contactarme",
              icon: "success",
              confirmButtonText: "Cerrar",
            })
            actions.resetForm()
          })

          .catch(() => {
            alert("Error")
          })
          .finally(() => actions.setSubmitting(false))
      }}
    >
      {({ isSubmitting }) => (
        <Form
          /* name="contact-demo"
          data-netlify={true} */
          name="contact"
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          className={contactFormStyles.form}
        >
          <input type="hidden" name="form-name" value="contact" />
          <label className={contactFormStyles.label} for="name">
            Nombre:
          </label>

          <Field
            className={contactFormStyles.field}
            type="text"
            name="name"
            placeholder="Ingresa tu nombre"
            autoFocus
          />
          <label className={contactFormStyles.label} for="email">
            Correo:
          </label>
          <ErrorMessage name="email" component="div" />

          <Field
            className={contactFormStyles.field}
            type="email"
            name="email"
            placeholder="Ingresa tu correo"
          />
          <label className={contactFormStyles.label} for="message">
            Mensaje:
          </label>

          <br />
          <Field
            className={contactFormStyles.textarea}
            component="textarea"
            name="message"
          />
          <br />
          <button
            className={contactFormStyles.button}
            type="submit"
            disabled={isSubmitting}
          >
            Enviar
          </button>
        </Form>
      )}
    </Formik>
  </div>
)

export default Contact
